import { CouncilChooserLayout } from '@/layouts/council-chooser/component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/council/$councilId')({
	component: CouncilChooserLayout,
});
